<button id="goToTop" [ngClass]="{ 'hide-bottom': !display }" (click)="gotoTop()">
  <i class="pi pi-chevron-up"></i>
</button>
